import { gql } from '@apollo/client';

export const fetchUserHistoryForEntitlementQueryPPC = gql`
  query fetchUserHistoryForEntitlementPPC($id: String, $filterOptions: [FilterOption], $transactionAccountId: String) {
    entitlementDetails(id: $id, filters: { transactionAccountId: $transactionAccountId }) {
      id
      subscriptionId
      edition
      userHistory(filterOptions: $filterOptions) {
        results {
          chargeElement
          quantity
          usersUpdate {
            isCreated
            isAdded
            isRemoved
            changeBy
          }
          lastUpdatedAt
        }
        nextId
      }
    }
  }
`;
